import React from "react";
import { IonSkeletonText } from "@ionic/react";

interface ArticleSkeletonListProps {
  count?: number;
}

const ArticleSkeleton: React.FC = () => (
  <div className="relative  flex w-full justify-center">
    <div className="relative w-full max-w-[576px]">
      {/* Image skeleton */}
      <IonSkeletonText
        animated
        className="rounded-[12px] w-full"
        style={{ height: "400px", borderRadius: "12px" }}
      />

      {/* Bottom Text Box */}
      <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/60 via-black/30 to-transparent pt-12">
        <div className="flex flex-col space-y-1">
          <IonSkeletonText
            animated
            className="h-[15px] w-[90%]"
            style={{ borderRadius: "4px" }}
          />
          <IonSkeletonText
            animated
            className="h-[15px] w-[40%]"
            style={{ borderRadius: "4px" }}
          />
          <div className="flex justify-between items-end">
            <div className="flex flex-col w-full space-y-0">
              <IonSkeletonText
                animated
                className="h-[10px] w-[95%]"
                style={{ borderRadius: "4px" }}
              />
              <IonSkeletonText
                animated
                className="h-[10px] w-[80%]"
                style={{ borderRadius: "4px" }}
              />
            </div>

            <IonSkeletonText
              animated
              className="h-[10px] w-[35px] ml-2"
              style={{ borderRadius: "4px" }}
            />
          </div>

          <div className="flex items-center gap-2">
            <IonSkeletonText
              animated
              className="h-[28px] w-[106px]  rounded-[12px]"
              style={{ borderRadius: "4px" }}
            />
            <IonSkeletonText
              animated
              className="h-[28px] w-[81px] rounded-[12px]"
              style={{ borderRadius: "4px" }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ArticleSkeletonList: React.FC<ArticleSkeletonListProps> = ({
  count = 2,
}) => {
  return (
    <>
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <ArticleSkeleton key={`skeleton-${index}`} />
        ))}
    </>
  );
};

export default ArticleSkeletonList;
